'use client';

import { useSearchParams } from 'next/navigation';
import { match } from 'ts-pattern';

import useCreateQueryString from '@/hooks/useCreateQueryString';

import MarketArtwork from './Categories/Artwork';
import MarketCollection from './Categories/Collection';
import MarketTrending from './Categories/Trending';

enum CategoryKey {
  Trending = 'trending',
  Collection = 'collection',
  Artwork = 'artwork',
}

const CATEGORIES = [
  { key: CategoryKey.Trending, title: 'Trending' },
  { key: CategoryKey.Collection, title: 'Collections' },
  { key: CategoryKey.Artwork, title: 'NFTs' },
];

const MarketplaceContent: React.FC = () => {
  const createQueryString = useCreateQueryString();
  const searchParams = useSearchParams();
  const categoryParam = searchParams.get('category');

  const handleFilterCategory = (key: CategoryKey) => {
    switch (key) {
      case CategoryKey.Trending:
        createQueryString(['category', 'page'], ['', ''], {}, ['assetCategory', 'tags', 'tagIds']);
        break;
      case CategoryKey.Collection:
        createQueryString(['category', 'page', 'createdAt'], [key, '', 'DESC'], {}, [
          'assetCategory',
          'tags',
          'tagIds',
        ]);
        break;
      case CategoryKey.Artwork:
        createQueryString(['category', 'page', 'assetCategory'], [key, 1, 'image']);
        break;
      default:
        createQueryString(['category', 'page'], [key, 1]);
        break;
    }
  };

  const renderContentWithType = () => {
    return match(categoryParam)
      .with(CategoryKey.Artwork, () => <MarketArtwork />)
      .with(CategoryKey.Collection, () => <MarketCollection />)
      .otherwise(() => <MarketTrending />);
  };

  return (
    <>
      <div className="relative mx-auto max-w-[1740px] px-[20px] 4xl:max-w-none 4xl:px-0">
        <div className="mx-[40px] flex items-center border-b-1 border-gray-100 py-5 md:mx-[20px]">
          {CATEGORIES.map((item, index) => (
            <span
              aria-expanded={index > 0}
              key={index}
              aria-checked={categoryParam === item.key || (index === 0 && !categoryParam)}
              onClick={() => handleFilterCategory(item.key)}
              className="cursor-pointer text-[24px] font-bold text-gray-400 aria-checked:text-black aria-expanded:ml-6 md:text-[18px] md:aria-expanded:ml-4"
            >
              {item.title}
            </span>
          ))}
        </div>
        {renderContentWithType()}
      </div>
    </>
  );
};

export default MarketplaceContent;
